import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { FadeIn, Eyebrow } from "@/components/Reveal";
import { ARTICLES } from "@/data/articles";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Insights() {
  const { t } = useLanguage();
  return (
    <div data-testid="insights-page">
      <Seo
        title="Insights — Commercial Insurance Guides | Wisdom Insurance Broking Pune"
        description="Plain-English guides on contractors all risk insurance, insurance for co-operative banks, business interruption and marine cargo — from an IRDAI-licensed broker in Pune."
        keywords="contractors all risk insurance, insurance for co-operative banks, business interruption insurance India, marine cargo insurance"
      />
      <section className="grain bg-navy-deep pb-16 pt-32 md:pb-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
          <FadeIn>
            <Eyebrow light>{t("in.eyebrow")}</Eyebrow>
            <h1 className="mt-4 max-w-3xl font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{t("in.title")}</h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{t("in.sub")}</p>
          </FadeIn>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8 md:py-20 lg:px-16">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {ARTICLES.map((a, i) => (
            <FadeIn key={a.slug} delay={i * 0.07}>
              <Link
                to={`/insights/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="group flex h-full flex-col border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-amber-500/50 hover:shadow-xl"
              >
                <div className="flex items-center justify-between font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
                  <span className="text-amber-700">{a.category}</span>
                  <span>{a.readTime} {t("in.minRead")}</span>
                </div>
                <h2 className="mt-4 font-heading text-xl font-semibold leading-snug text-navy group-hover:text-amber-800">{a.title}</h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{a.excerpt}</p>
                <span className="mt-6 flex items-center gap-1.5 font-mono text-xs font-medium uppercase tracking-[0.2em] text-amber-700">
                  {t("in.read")}
                  <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            </FadeIn>
          ))}
        </div>
      </section>
    </div>
  );
}
